import { syncAction, syncSelector, syncReducer } from '../utils'

const { createClearAction, createSetAction } = syncAction
const name = 'createAccountModal'

export const set = (data) => (createSetAction(name, data))
export const clear = () => (createClearAction(name))

export const reducer = syncReducer(name)
export const selector = syncSelector(name)



// WEBPACK FOOTER //
// ./src/store/auth/createAccountModal.js